import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  betaRibbon: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    gap: "12px"
    // marginBottom: "16px"
  },

  betaBadge: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "500",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
    whiteSpace: "nowrap"
  }

}));
